var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-5 col-md-6"},[_c('user-card'),_c('members-card')],1),_c('div',{staticClass:"col-xl-8 col-lg-7 col-md-6"},[_c('edit-profile-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }